import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next';




const StartUp = () => {

    const { t } = useTranslation();
  return (
    <Flex
        px={{ md: 'inherit', '2xl': "19%", base: 4 }}
        position={'relative'}
        py={{'2xl': 40, base: 20}}
        overflow={'hidden'}
        justifyContent={'center'}
    >


        
     <Box
        rounded={40}
        overflow={'hidden'}
        w={'full'} 
        pos={'relative'}
        spacing={12}
        dir={'column'}
        bgImg={`url(${require('../../../assets/services/4.png')})`}
        bgRepeat= 'no-repeat'
        bgPos='bottom'
        bgSize={'cover'}
        align={'center'}
        h={'full'}
        _before={{
        position: 'absolute',
        zIndex: 100,
        content: "''",
        //bg: 'blackAlpha.900',
        opacity: 0.8,
        bgGradient: 'to-tl',
        gradientFrom: 'blue.900',
        gradientTo: 'red.700',
        w: 'full',
        h: 'full',
        top: 0,
        left: 0
        }} px={{md: '100px', base: 4}}  py={{md: 20, base: 14}} >
        <Box textAlign={'center'} display={'flex'} flexDir={'column'} alignItems={'center'} justifyContent={'center'} w={'full'} h={'full'} zIndex={101} position={'relative'}>
            <Box color={'white'} w={{md: '4xl', base: 'full'}}>
                <Heading fontFamily={'Poppins'} letterSpacing={-0.9} fontSize={{md: '5xl', base: '2xl'}} lineHeight={1.2} >{t('startUpTitleServiceThree')}</Heading>
                <Text  mt={4} fontSize={{md: 'xl', base: 'md'}}>{t('startUpSubtitleServiceThree')}</Text>
            </Box>

            <Button fontFamily={'Momo Trust Display'} size={'lg'} p={6} rounded={'full'} colorPalette={'blue'} mt={6} >
                {t('startUpCallToActionServiceThree')}
            </Button>
        </Box>
        
        </Box>
    </Flex>
  )
}

export default StartUp